export const popoverDefaultSlotProps = {
    disableScrollLock: true,
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
    transformOrigin: { vertical: 'top', horizontal: 'left' },
};
export function getPopoverPaperSx(theme, anchorWidth, paperSx) {
    return {
        bgcolor: theme.palette.background.subtle,
        color: theme.palette.typography.primary,
        mt: 0.5,
        ...(anchorWidth != null && { width: anchorWidth }),
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        ...paperSx,
    };
}
